export enum SettingPage {
  UserSettings = 1,
  UserAccessRights = 2,
  UserContentPreferences = 3,
  UserAgreements= 4
}
